//import siteSearch360 from './sitesearch360';
// https://github.com/thednp/bootstrap.native/wiki/How-to-use#es6-basic-example
import Bootstrap from './vendor/bootstrap-native-4.1.2/bootstrap-native-esm';

window.modal = function (name, option) {
  let targetModal = document.querySelector(`#modal-${name}`);
  let contentModal = document.querySelector(`#modal-content-${name}`);
  let defaultModal = document.querySelector('#modal-default');

  if (targetModal) {
    new Bootstrap.Modal(targetModal).show()
  } else if (contentModal) {
    let modal = defaultModal.cloneNode(true);
    modal.classList.add(`modal-${name}`);
    modal.setAttribute('id', `modal-${name}`);
    document.querySelector('body').append(modal);

    $(modal).find('.modal-body').prepend($(contentModal).contents());

    // Remove (empty) content holder
    contentModal.remove();

    // Start modal
    new Bootstrap.Modal(modal).show();

    if (name === 'video') {
      // remove iframe to stop video
      modal.addEventListener('hidden.bs.modal', function () {
        modal.querySelector('iframe')?.setAttribute('src', 'about:blank');
      });
    }
  }

  if ((name === 'audio') && (typeof option !== 'undefined')) {
    document.querySelectorAll('#form-products').forEach((el) => el.value = option);
  }

  if ((name === 'mailchimp') && (typeof option !== 'undefined')) {
    document.querySelectorAll('#modal-mailchimp form').forEach((el) => {
      el.setAttribute('action', option);
    });
  }
};

window.searchModal = () => {
  //siteSearch360(() => {
    modal('search');
  //});
};

window.video = function (videoURL) {
  modal('video');
  document.querySelectorAll('#modal-video iframe').forEach((el) => {
    el.setAttribute('src', videoURL);
  });
};

window.optionsModal = function (modalName, option) {
  modal(modalName);
  let el = document.querySelector('#modal-' + modalName + ' .typography');
  if (option === 'profi') {
    el.classList.remove('modal-hide-first-button');
    el.classList.add('modal-hide-second-button');
  } else {
    el.classList.remove('modal-hide-second-button');
    el.classList.add('modal-hide-first-button');
  }
};
